<script lang="ts">
    export const GrantSearchLoadingItem = "all";
</script>

<div class="h-32 rounded-lg mt-3 inline-block loading_background col-span-7"></div>

<style>
    @keyframes moving-gradient {
        0% {
            background-position: -250px 0;
        }
        100% {
            background-position: 250px 0;
        }
    }

    div.loading_background {
        background: linear-gradient(to right, #eee 20%, #ddd 50%, #eee 80%);
        background-size: 500px 100px;
        animation-name: moving-gradient;
        animation-duration: 1s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
        animation-fill-mode: forwards;
    }
</style>
